import type { HeadData } from "@base/site/head";

function upsertMeta(
  attribute: "name" | "property",
  key: string,
  content: string
) {
  let element = document.head.querySelector<HTMLMetaElement>(
    `meta[${attribute}="${key}"]`
  );
  if (!element) {
    element = document.createElement("meta");
    element.setAttribute(attribute, key);
    document.head.appendChild(element);
  }
  element.setAttribute("content", content);
}

/** Exactly one canonical: drops extra ones (e.g. duplicated by old prerenders). */
function setCanonical(href: string) {
  const links = document.head.querySelectorAll<HTMLLinkElement>(
    'link[rel="canonical"]'
  );
  links.forEach((link, index) => {
    if (index > 0) link.remove();
  });
  let link = links[0];
  if (!link) {
    link = document.createElement("link");
    link.rel = "canonical";
    document.head.appendChild(link);
  }
  link.href = href;
}

/** Updates the document head in place (no script injection, Trusted Types safe). */
export function applyHead(head: HeadData) {
  document.title = head.title;
  upsertMeta("name", "description", head.description);
  if (document.head.querySelector('meta[name="title"]')) {
    upsertMeta("name", "title", head.title);
  }
  upsertMeta(
    "name",
    "robots",
    head.robots === "noindex" ? "noindex" : "index, follow"
  );
  setCanonical(head.canonical);

  upsertMeta("property", "og:type", head.ogType);
  upsertMeta("property", "og:url", head.canonical);
  upsertMeta("property", "og:title", head.title);
  upsertMeta("property", "og:description", head.description);
  upsertMeta("property", "og:image", head.image);

  upsertMeta("name", "twitter:url", head.canonical);
  upsertMeta("name", "twitter:title", head.title);
  upsertMeta("name", "twitter:description", head.description);
  upsertMeta("name", "twitter:image", head.image);
}
